import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../views/store/index'
// 公共组件 侧边栏 顶部 底部
import main from '@/views/components/HelloWorld'
//pc 登录页
import login from '@/views/login.vue'
import NotFound from '@/views/publicComponents/notFound.vue'

import globalPath from '@/assets/script/globalPath'
import common from '@/assets/script/common.js'

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            component: main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/",
                    redirect: '/home'
                }
            ]
        }
    ]
});
let router_lise = [];
// 未登录路由拦截
router.beforeEach((to, from, next) => {
    let isLogin = common.getCookie('tibiot-personal-card'); // 获取token
    //路由设置
    if (isLogin) {
        getMbx(to); //获取面包屑
        getMenuId(to.meta.index) //获取当前页面的按钮权限
        if (router_lise == 0) { //路由开始
            getRouters(to,from, next);
        } else {
            next()
        }
    }else {
        if (to.path == '/login') {
            router_lise = [];
            next()
        }else {
            router_lise = [];
            next({path: "/login"})
        }
    }
});
// 当在渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
router.onError((error) => {
    console.log('error:'+ error.message); 
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      window.location.reload();
    }else{
      console.log(error)
    }
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

//获取页面按钮
function getMenuId(index){
    if(index){
        axios({
            method: 'post',
            url: globalPath.globalPath.api + 'admin/role/getSysRoleMenu',
            data: {menuId:index},
        })
        .then(function (res) {
            if (res.data.code == 200 ) {
                if(Array.isArray(res.data.data)){
                    store.commit('setButtons', res.data.data);//存储页面的按钮
                }else{
                    store.commit('setButtons', []);//存储页面的按钮
                }
            }
        }).catch(() => console.log('获取页面按钮Error'));
    }
}
//设置面包屑
function getMbx(to){
    if (getCrumbs(to).flog) {
        let cc = store.state.jumpMenu;
        if (store.state.jumpMenu.index == 2){
            getCrumbs(to).bb[2] = cc;
        } else {
            getCrumbs(to).bb[1] = cc;
        } 
        store.commit('setCrumbsArr', getCrumbs(to).bb);
    } else {
        store.commit('setCrumbsArr', getCrumbs(to).mianbaoxian);
    }
}
//获取面包屑
function getCrumbs(to){
    let bb = store.state.crumbsArr; //储存面包屑
    let arrmenu = store.state.menu;
    let mianbaoxian = [];
    let flog = true;
    for (let i = 0; i < arrmenu.length; i++) {
        if (arrmenu[i].menuUrl == to.path) {
            mianbaoxian[0] = {
                name: arrmenu[i].menuName,
                url: arrmenu[i].menuUrl,
                // icon: arrmenu[i].menuIcon,
            };
            mianbaoxian.length = 1;
            flog = false;
            break;
        } else {
            if (arrmenu[i].children) {
                for (let j = 0; j < arrmenu[i].children.length; j++) {
                    if (arrmenu[i].children[j].menuUrl == to.path) {
                        mianbaoxian[0] = {
                            name: arrmenu[i].menuName,
                            url: arrmenu[i].children[j].menuUrl,
                            // icon: arrmenu[i].menuIcon,
                        };
                        mianbaoxian[1] = {
                            name: arrmenu[i].children[j].menuName,
                            url: arrmenu[i].children[j].menuUrl
                        };
                        mianbaoxian.length = 2;
                        flog = false;
                        break;
                    }
                }
            }
        }
    }
    return {bb,mianbaoxian,flog}
}

//获取路由
function getRouters(to, from, next) {
    router_lise = [];
    axios({
        method: 'post',
        url: globalPath.globalPath.api + 'home/getSysMenuRoute',
    })
    .then(function (res) {
        if (res.data.code == 200 && Array.isArray(res.data.data) && res.data.data.length) {
            router_lise = addDynamicRoutes(res.data.data);
            router.options.routes[1].children = router_lise;
            router.options.routes[2] = {path: '/404', name: '404', component: NotFound};
            router.options.routes[3] = {path: '*', redirect: '/404'};
            router.matcher = new Router().matcher;
            router.addRoutes(router.options.routes);
            if(from.path == '/login' || from.path == '/'){
                next({path: "/home"});
            }else{
                next({...to});
            }
        }else{
            if (to.path === '/login') {
                next()
            } else {
                next({path: "/login"})
            }
        }
        
    }).catch(function (err) {
        if (to.path === '/login') {
          next()
        } else {
          next({path: "/login"})
        }
      })
}
function addDynamicRoutes(menuList = [], routes = []) {
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].menuUrl) {
            let url = menuList[i].menuUrl;
            let route = {
                path: url,
                name: url.substr(1),
                component: () => import(`@/views/page${url}`),
                meta: {
                    index: menuList[i].id,
                    name: menuList[i].menuName
                }
            };
            routes.push(route);
        }
    }
    return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js